import { Outlet, createRootRoute } from "@tanstack/react-router";
import { ToastContainer } from "../components/ui/toast.js";
import { ConnectionNotice } from "../components/feedback/ConnectionNotice.js";

/**
 * Root route — wraps every page in the app. No auth check happens here;
 * gates live on `routes/_authenticated.tsx`. Public routes (login, register,
 * forgot-password) render directly under this root.
 *
 * The ToastContainer is mounted here so toasts are available on both public
 * pages (register, accept-invite) and the authenticated shell. The
 * ConnectionNotice ("Reconnecting…") sits here too, so it shows over the
 * loading screen as well as the desktop.
 *
 * Devtools (TanStack Router + Query) are intentionally not mounted yet —
 * they ship in a later step once we've wired the in-app dev menu.
 */
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <ConnectionNotice />
      <ToastContainer />
    </>
  );
}
